// Error messaging when field has error on validation

export const ErrorMessages = {
  FIELD_ERROR: 'Please enter a valid ',
};

export const MapFieldToErrorMessage = {
  graduationyear: 'graduation year',
  firstname: 'first name',
  lastname: 'last name',
  phone: 'phone number',
  birthday: 'date of birth',
  enrolltermyear: 'enrollment year',
  levelofstudy: 'level of study',
  child_email: 'email for your child',
  street: 'street address',
  birthdate: 'birth date',
};

export const DEFAULT_SUBMISSION_ERROR_MESSAGE = 'Something went wrong.';

export default {
  ErrorMessages,
  MapFieldToErrorMessage,
  DEFAULT_SUBMISSION_ERROR_MESSAGE,
};
